module.exports = __webpack_public_path__ + "img/Stat_energy.fe3eb58e.png";